import { render, staticRenderFns } from "./threeShelf.vue?vue&type=template&id=fcb0548c&scoped=true&"
import script from "./threeShelf.vue?vue&type=script&lang=js&"
export * from "./threeShelf.vue?vue&type=script&lang=js&"
import style0 from "./threeShelf.vue?vue&type=style&index=0&id=fcb0548c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0548c",
  null
  
)

export default component.exports